define('views/modules/calendar/animated-session/exercise/lists/week-brief/week-exercise-list',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // parent
    'views/modules/calendar/animated-session/exercise/lists/exercise-list',
    // views
    'views/modules/calendar/animated-session/exercise/lists/week-brief/week-exercise-list-item'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VExerciseList,
    VWeekExerciseListItem
) {

    var VWeekExerciseList = VExerciseList.extend({
        exerciseView: VWeekExerciseListItem,
        sortable: false
    });

    return VWeekExerciseList;

});

